export const STATIC_PAGE_SEO = {
  // Static pages
  about: { robots: 'index, follow' },
  contact: { robots: 'index, follow' },
  support: { robots: 'index, follow' },
  privacy: { robots: 'index, follow' },
  terms: { robots: 'noindex, follow' },

  // Dynamic game pages
  memorama: { robots: 'index, follow' },
  puzzle: { robots: 'index, follow' },

  // Special pages
  'not-found': { robots: 'noindex, follow' }
}
